import {configureStore} from "@reduxjs/toolkit/react";
import {useDispatch} from "react-redux";
import resources from './resources'
import bids from "./bids";
import filters from "./filters";
import users from "./users";
import stores from "./stores";

export const store = configureStore({
    reducer: {
        resources,bids,filters,users,stores
    },
    devTools: true,
});

export const useStoreDispatch = () => useDispatch<typeof store.dispatch>()
export type RootState = ReturnType<typeof store.getState>
